import {Fn, PageFunctionKey, PageFunctionTypeKey} from './types'

export class PageFunctionsRegistry {
  private map = new Map<PageFunctionKey, Map<PageFunctionTypeKey, Fn>>()

  register<T extends Fn>(key: PageFunctionKey, fn: T, fnType: PageFunctionTypeKey) {
    let fnTypesMap: Nullable<Map<PageFunctionTypeKey, Fn>> = null

    if (this.map.has(key)) {
      fnTypesMap = this.map.get(key) as Map<PageFunctionTypeKey, Fn>
    } else {
      fnTypesMap = new Map<PageFunctionTypeKey, Fn>()
    }

    if (fnTypesMap.has(fnType)) {
      throw new Error(`Page function type "${fnType}" already registered`)
    }

    fnTypesMap.set(fnType, fn)
    this.map.set(key, fnTypesMap)
  }

  get<T extends Fn>(key: PageFunctionKey, fnType: PageFunctionTypeKey): T {
    const fnTypeMap = this.map.get(key)
    if (!fnTypeMap) {
      throw new Error(`Page function "${key}" not registered`)
    }
    if (fnTypeMap.has(fnType)) {
      return fnTypeMap.get(fnType) as T
    } else {
      throw new Error(`Page function type "${fnType}" not registered`)
    }
  }
}
